import React from 'react'
import { reduxForm, Field } from 'redux-form'
import WrappedInput from '../../Shared/Forms/WrappedInput'
import FormError from '../../Shared/Forms/FormError'
import Card from '../../Shared/Card'
import Button from '../../Shared/Button'

const FORM_NAME = 'inviteUserForm'

const ROLE_OPTIONS = [
  { label: 'Analyst', value: 'analyst' },
  { label: 'Editor', value: 'editor' },
  { label: 'Admin', value: 'admin' },
]

const validate = values => {
  let errors = {}

  if (!values.email) {
    errors.email = 'Please enter an email.'
  }

  return errors
}

const Form = function InviteForm({ handleSubmit, submitting, onClose, error }) {
  return (
    <Card
      component="form"
      onSubmit={handleSubmit}
      actions={
        <>
          <Button text type="button" onClick={onClose}>
            Cancel
          </Button>
          <Button loading={submitting}>Invite</Button>
        </>
      }
    >
      <h1>Invite User</h1>
      <Field component={WrappedInput} name="email" label="Email" />
      <Field
        component={WrappedInput}
        name="role"
        label="Role"
        options={ROLE_OPTIONS}
      />
      {error && <FormError>{error}</FormError>}
    </Card>
  )
}

export default reduxForm({
  form: FORM_NAME,
  validate,
})(Form)
